const rsWebProductModel = window.rs.web.product.model;
export const initialImageCarouselState = {
  ImageCarousel: {
    images: rsWebProductModel.images,
    maxCarouselSize: rsWebProductModel.maxCarouselSize,
    shared: {
      isShared: rsWebProductModel.shared.isShared,
      sharedMessage: rsWebProductModel.shared.sharedMessage,
    },
    video: {
      thumbnailURL: rsWebProductModel.video.thumbnailURL,
      videoURL: rsWebProductModel.video.videoURL,
    },
    vfmFlagImages: rsWebProductModel.vfmFlagImages,
    selectedImageIndex: 0,
    currentPosition: 0,
    isVideoDisplayed: false,
    is360Display: rsWebProductModel.is360Display,
    productGalleryContentCloudName: rsWebProductModel.productGalleryContentCloudName,
    productNumber: rsWebProductModel.productNumber,
  },
};




// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/store/middleware/initialState.js